import { gql } from '@apollo/client';

export const GET_PEOPLE = gql`
query Users($search: String, $tagIds: [Int!], $missingConsent: Boolean) {
  users(search: $search, tagIds: $tagIds, missingConsent: $missingConsent) {
    photoUrl
    identifier
    name
    id
    preferredName
    scriptName
    hasNewRegistration
    tags {
        id
        name
    }
  }
}`;
